/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import WieSettings from 'eflex/constants/work-instructions/wie-settings';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

const MAX_PREVIEW_HEIGHT = 45;
const MIN_WIDTH = 100;
const MIN_HEIGHT = 100;

export default class WorkInstructionEditorSizeCard extends Component {
  MIN_WIDTH = MIN_WIDTH;
  MIN_HEIGHT = MIN_HEIGHT;

  @tracked customWidth;
  @tracked customHeight;

  get isCustom() {
    return this.args.sizeCard.type === WieSettings.getStartedTypes.CUSTOM;
  }

  get previewWidth() {
    const scale = MAX_PREVIEW_HEIGHT / this.args.sizeCard.height;
    return `${Math.round(this.args.sizeCard.width * scale * 2) / 2}px`;
  }

  get previewHeight() {
    return `${MAX_PREVIEW_HEIGHT}px`;
  }

  @action
  cardClick() {
    let setValue;

    if (this.args.isSelected) {
      setValue = null;
    } else {
      setValue = this.args.sizeCard;
    }

    this.args.cardClick?.(setValue);
  }

  @action
  setWidth(value) {
    if (value < MIN_WIDTH) {
      this.customWidth = MIN_WIDTH;
    } else {
      this.customWidth = value;
    }
  }

  @action
  setHeight(value) {
    if (value < MIN_HEIGHT) {
      this.customHeight = MIN_HEIGHT;
    } else {
      this.customHeight = value;
    }
  }
}
